import { X } from 'lucide-react';
import { Drawer } from 'vaul';
import type { WatchlistSort } from './AppShell.types';

const watchlistSortOptions: { value: WatchlistSort; label: string }[] = [
  { value: 'manual', label: 'Manual' },
  { value: 'flag', label: 'Flag' },
  { value: 'symbol', label: 'Symbol A-Z' },
  { value: 'gainers', label: 'Gainers' },
  { value: 'losers', label: 'Losers' },
  { value: 'price', label: 'Price' },
];

export function WatchlistOptionsSheet({ open, sort, canManageWatchlists, canDeleteWatchlist, onSortChange, onAddSymbol, onImportWatchlist, onAddSection, onRenameWatchlist, onDeleteWatchlist, onOpenChange }: {
  open: boolean;
  sort: WatchlistSort;
  canManageWatchlists: boolean;
  canDeleteWatchlist: boolean;
  onSortChange(sort: WatchlistSort): void;
  onAddSymbol(): void;
  onImportWatchlist(): void;
  onAddSection(): void;
  onRenameWatchlist(): void;
  onDeleteWatchlist(): void;
  onOpenChange(open: boolean): void;
}) {
  return (
    <Drawer.Root open={open} onOpenChange={onOpenChange}>
      <Drawer.Portal>
        <Drawer.Overlay className="drawer-overlay" />
        <Drawer.Content className="drawer-content watchlist-options-sheet" aria-describedby={undefined}>
          <div className="sheet-handle" aria-hidden="true" />
          <div className="sheet-header">
            <Drawer.Title asChild><strong>Watchlist options</strong></Drawer.Title>
            <Drawer.Close asChild>
              <button type="button" className="icon-button" aria-label="Close watchlist options"><X size={24} strokeWidth={1.9} /></button>
            </Drawer.Close>
          </div>
          <div className="sheet-section-label">Sort</div>
          <div className="sheet-option-list">
            {watchlistSortOptions.map((option) => (
              <button
                key={option.value}
                type="button"
                className={option.value === sort ? 'sheet-option active' : 'sheet-option'}
                onClick={() => {
                  onSortChange(option.value);
                  onOpenChange(false);
                }}
              >
                <span>{option.label}</span>
                {option.value === sort && <span aria-hidden="true">✓</span>}
              </button>
            ))}
          </div>
          <div className="sheet-section-label">Actions</div>
          <button type="button" className="sheet-action-button" onClick={onAddSymbol}>Add symbol</button>
          <button type="button" className="sheet-action-button" onClick={onAddSection}>Add section</button>
          {canManageWatchlists && <button type="button" className="sheet-action-button" onClick={onImportWatchlist}>Import watchlist</button>}
          {canManageWatchlists && <button type="button" className="sheet-action-button" onClick={onRenameWatchlist}>Rename watchlist</button>}
          {canManageWatchlists && <button type="button" className="sheet-action-button sheet-action-button-danger" onClick={onDeleteWatchlist} disabled={!canDeleteWatchlist}>Delete watchlist</button>}
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
